import { Component, HostBinding, Input, Output, OnInit, ChangeDetectionStrategy, TemplateRef } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
    standalone: false,
    selector: 'zq-tab',
    template: `
        <ng-template *ngIf="active" [ngTemplateOutlet]="templateRef"></ng-template>
    `,
    styleUrls: ['./zq-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush

})
export class ZQTabComponent implements OnInit {
    private _active = false;

    @Input()
    label: string;

    @Input() templateRef: TemplateRef<any>;

    @Input()
    set active(value) {
        this._active = value;
        this.isActive.emit(this._active);
    }

    get active() {
        return this._active;
    }

    @Input()
    name: string;

    @Input()
    disabled = false;

    @HostBinding('class')
    readonly hostClass = 'zq-tab';

    @Output()
    isActive = new EventEmitter<boolean>();

    ngOnInit() {
        // console.log(`ZQTabComponent.ngOnInit :: name: ${this.name}, label ${this.label}`);
    }
}
